import React from 'react';

import * as styles from './styles';

interface AlertLeftIconProps {
  icon: JSX.Element;
}

export const AlertLeftIcon: React.FC<AlertLeftIconProps> = React.memo(
  ({ icon }: any) => <div className={styles.alertLeftIcon}>{icon}</div>
);
